module.exports = __webpack_public_path__ + "static/media/Apercu-Medium.c1db2c6a.woff";